import React from "react";
import { Link } from "react-router-dom";
import {useDispatch} from "react-redux";
import {userProfileApi} from "../../../../../common/userViewCount";
import {getUserInfo} from "../../../../../../services/authService";
import {imageDownloadUrl} from '../../../../../../config'
export default function TrendingProfileCard(props) {
  const profileStatus = useDispatch()
  const getInitials = () => {
      let initial = "";
      if(props?.data?.athleteFirstName){
      initial= props.data.athleteFirstName[0]?.toUpperCase().concat(props.data.athleteLastName ? props.data.athleteLastName[0]?.toUpperCase() : '');
      }
      return initial;
    };
  return (
    <>
      <div className="item">
        <div className="imgDataFlexBox">
          <div className="imgBox">
             {props.data && props.data.profileImages ? (
                <img src={`${imageDownloadUrl}/${props.data.profileImages}`} alt="profile" className="image" style={{width: '100px', height: 'auto'}}/>
                   ) : <div className = 'initialLetter'><span>{getInitials()}</span></div>
             }
            {props.data && props.data.verifiedUser ? (
              <span className="icon blueCheck">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26.418"
                  height="26.403"
                  viewBox="0 0 26.418 26.403"
                >
                  <defs>
                    <style></style>
                  </defs>
                  <path
                    className="a"
                    d="M-4229.021-6663.778a1.151,1.151,0,0,1-.986-.543,1.174,1.174,0,0,0-.993-.543,1.174,1.174,0,0,0-.993.543,1.151,1.151,0,0,1-.986.543,1.169,1.169,0,0,1-1.152-.9v-.005a1.179,1.179,0,0,0-1.149-.9,1.16,1.16,0,0,0-.728.256,1.169,1.169,0,0,1-.729.259,1.2,1.2,0,0,1-.883-.392,1.158,1.158,0,0,1-.3-.9l0-.013a1.161,1.161,0,0,0-.3-.9,1.184,1.184,0,0,0-.87-.387,1.181,1.181,0,0,0-.395.068h-.005a1.189,1.189,0,0,1-.4.07,1.175,1.175,0,0,1-.984-.544,1.155,1.155,0,0,1-.084-1.116l.01-.021a1.174,1.174,0,0,0-.088-1.121,1.175,1.175,0,0,0-.989-.538h-.033a1.163,1.163,0,0,1-1.08-.708,1.164,1.164,0,0,1,.219-1.274l.019-.019a1.171,1.171,0,0,0,.28-1.09,1.176,1.176,0,0,0-.769-.831l-.02,0a1.164,1.164,0,0,1-.8-1.02,1.164,1.164,0,0,1,.621-1.138l.02-.01a1.174,1.174,0,0,0,.621-.943,1.172,1.172,0,0,0-.456-1.031l-.02-.017a1.161,1.161,0,0,1-.425-1.223,1.164,1.164,0,0,1,.957-.875l.017,0a1.174,1.174,0,0,0,.894-.688,1.172,1.172,0,0,0-.1-1.125l-.013-.021a1.159,1.159,0,0,1-.058-1.2,1.173,1.173,0,0,1,1.03-.625,1.229,1.229,0,0,1,.215.019h.008a1.234,1.234,0,0,0,.21.019,1.166,1.166,0,0,0,.928-.459,1.169,1.169,0,0,0,.207-1.017l0-.017a1.148,1.148,0,0,1,.2-1.012,1.2,1.2,0,0,1,.938-.467,1.169,1.169,0,0,1,.572.151,1.16,1.16,0,0,0,.571.15,1.186,1.186,0,0,0,1.177-1.092v-.01a1.176,1.176,0,0,1,1.184-1.092,1.158,1.158,0,0,1,.866.39,1.159,1.159,0,0,0,.871.39,1.18,1.18,0,0,0,1.086-.715,1.162,1.162,0,0,1,1.084-.717,1.162,1.162,0,0,1,1.084.715,1.18,1.18,0,0,0,1.086.717,1.159,1.159,0,0,0,.871-.39,1.158,1.158,0,0,1,.866-.39,1.176,1.176,0,0,1,1.184,1.092v.01a1.186,1.186,0,0,0,1.177,1.092,1.16,1.16,0,0,0,.569-.148,1.164,1.164,0,0,1,.574-.153,1.2,1.2,0,0,1,.938.467,1.148,1.148,0,0,1,.2,1.012l-.005.017a1.169,1.169,0,0,0,.207,1.017,1.166,1.166,0,0,0,.928.459,1.234,1.234,0,0,0,.21-.019h.008a1.229,1.229,0,0,1,.215-.019,1.172,1.172,0,0,1,1.029.625,1.158,1.158,0,0,1-.057,1.2l-.013.021a1.172,1.172,0,0,0-.1,1.125,1.174,1.174,0,0,0,.894.688l.017,0a1.164,1.164,0,0,1,.958.875,1.161,1.161,0,0,1-.425,1.222l-.021.017a1.173,1.173,0,0,0-.456,1.032,1.174,1.174,0,0,0,.621.943l.021.01a1.164,1.164,0,0,1,.621,1.138,1.164,1.164,0,0,1-.8,1.02l-.02,0a1.179,1.179,0,0,0-.769.831,1.171,1.171,0,0,0,.283,1.09l.016.019a1.164,1.164,0,0,1,.218,1.273,1.163,1.163,0,0,1-1.08.708h-.033a1.175,1.175,0,0,0-.989.538,1.174,1.174,0,0,0-.088,1.121l.01.021a1.154,1.154,0,0,1-.083,1.116,1.175,1.175,0,0,1-.984.544,1.185,1.185,0,0,1-.4-.07h-.005a1.181,1.181,0,0,0-.395-.068,1.184,1.184,0,0,0-.87.387,1.161,1.161,0,0,0-.3.9v.013a1.157,1.157,0,0,1-.3.9,1.2,1.2,0,0,1-.883.392,1.159,1.159,0,0,1-.727-.259,1.164,1.164,0,0,0-.729-.256,1.181,1.181,0,0,0-1.15.9v0A1.168,1.168,0,0,1-4229.021-6663.778Zm-7.2-15.261a.709.709,0,0,0-.522.232l-1.041,1.122a.835.835,0,0,0,0,1.12l4.787,5.15a.712.712,0,0,0,.522.231.71.71,0,0,0,.52-.231l8.471-9.111a.84.84,0,0,0,0-1.122l-1.041-1.12a.711.711,0,0,0-.522-.232.705.705,0,0,0-.521.232l-6.908,7.43-3.226-3.469A.706.706,0,0,0-4236.221-6679.039Z"
                    transform="translate(4244.209 6690.181)"
                  />
                </svg>
              </span>
            ) : (
              <span className="icon redAlert">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25.828"
                  height="25.997"
                  viewBox="0 0 25.828 25.997"
                >
                  <defs>
                    <style></style>
                  </defs>
                  <g transform="translate(-306 -179)">
                    <path
                      className="a"
                      d="M-5645.777-718.874a1.147,1.147,0,0,1,2.111,0l0,.009a1.147,1.147,0,0,0,1.91.317h0a1.146,1.146,0,0,1,2,.68l0,.034a1.146,1.146,0,0,0,1.7.916l.008,0a1.146,1.146,0,0,1,1.669,1.288l-.016.062a1.146,1.146,0,0,0,1.31,1.416l.033-.006a1.146,1.146,0,0,1,1.159,1.758l-.047.071a1.147,1.147,0,0,0,.776,1.761l.063.01a1.146,1.146,0,0,1,.521,2.038l-.071.055a1.146,1.146,0,0,0,.16,1.916l.074.04a1.146,1.146,0,0,1-.175,2.1l-.072.024a1.146,1.146,0,0,0-.474,1.864l.061.066a1.146,1.146,0,0,1-.852,1.924h-.049a1.147,1.147,0,0,0-1.058,1.61l.031.07a1.146,1.146,0,0,1-1.433,1.544l-.019-.007a1.147,1.147,0,0,0-1.527,1.182l0,.049a1.147,1.147,0,0,1-1.859,1l0,0a1.146,1.146,0,0,0-1.831.625l0,.02a1.146,1.146,0,0,1-2.082.344v0a1.146,1.146,0,0,0-1.937,0v0a1.146,1.146,0,0,1-2.082-.344l0-.02a1.146,1.146,0,0,0-1.831-.625l0,0a1.146,1.146,0,0,1-1.859-1l0-.049a1.146,1.146,0,0,0-1.527-1.182l-.019.007a1.146,1.146,0,0,1-1.434-1.544l.031-.07a1.146,1.146,0,0,0-1.057-1.61h-.049a1.146,1.146,0,0,1-.852-1.924l.061-.066a1.146,1.146,0,0,0-.474-1.864l-.072-.024a1.146,1.146,0,0,1-.175-2.1l.075-.04a1.146,1.146,0,0,0,.16-1.916l-.071-.055a1.146,1.146,0,0,1,.521-2.038l.062-.01a1.146,1.146,0,0,0,.777-1.761l-.047-.071a1.146,1.146,0,0,1,1.158-1.758l.034.006a1.146,1.146,0,0,0,1.31-1.416l-.016-.062a1.146,1.146,0,0,1,1.669-1.288l.008,0a1.146,1.146,0,0,0,1.7-.916l0-.034a1.146,1.146,0,0,1,2-.68h0a1.146,1.146,0,0,0,1.91-.317Z"
                      transform="translate(5963.635 898.573)"
                    ></path>
                    <path
                      className="b"
                      d="M4.452-10.374,4.13-3.7H1.792L1.47-10.374ZM2.968.112A1.676,1.676,0,0,1,1.8-.287,1.309,1.309,0,0,1,1.358-1.3,1.33,1.33,0,0,1,1.8-2.324,1.658,1.658,0,0,1,2.968-2.73a1.638,1.638,0,0,1,1.155.406A1.33,1.33,0,0,1,4.564-1.3,1.315,1.315,0,0,1,4.123-.294,1.638,1.638,0,0,1,2.968.112Z"
                      transform="translate(315.642 197.374)"
                    ></path>
                  </g>
                </svg>
              </span>
            )}
          </div>
          <div className="dataFlexBox">
            <div>
              <h5 onClick={()=>{
                profileStatus({type:"CHANGE_ATHLETE_PROFILE_VIEW_STATE", payload:{
                    id:props?.data?.id || 0,
                    status: true
                  }});
                localStorage.setItem('pubViewID',props?.data.id || 0)
                userProfileApi({obj:{userrole:"ATHLETES", profileviewedby: getUserInfo()?.id ?? 0, profileviewto: +props?.data?.id || 0 }},true, false)
              }}>
                <Link to={`/athlete/${props?.data?.athleteFirstName?.trim()?.toLowerCase()?.toString()?.split(" ").join("-")}-${props?.data?.athleteLastName?.trim()?.toLowerCase()?.toString()?.split(" ").join("-")}-${props?.data?.sysGenId}`}
                      target="_blank"
                >
                {props.data
                  ? props.data.athleteFirstName +
                    " " +
                    props.data.athleteLastName
                  : ""}
                </Link>
              </h5>
              <ul>
                <li>
                  <span style={{marginRight:"5px"}}>
                    {props.data ? props.data.sportName : ""} -{" "}
                    {props.data
                      ? props.data.primaryPosition
                        ? props.data.primaryPosition
                        : props.data.secondaryPosition
                        ? props.data.secondaryPosition
                        : ""
                      : ""}
                  </span>
                </li>
                <li>
                  <span style={{margin:"0 5px 0 5px"}}>
                    Grad Year {props.data ? props.data.yearValue : ""}
                  </span>
                </li>
              </ul>
              <ul>
                <li>
                  {/*<span>*/}
                  {/*  {props.data ? props.data.totalFollowers : 0} Followers*/}
                  {/*</span>*/}
                </li>
                <li>
                  {/*<span>*/}
                  {/*  {props.data ? props.data.totalFollowing : 0} Follow*/}
                  {/*</span>*/}
                </li>
              </ul>
            </div>
            <div className="action">
              {props.data && props.data.followeingStatus ? (
                  <></>
                // <Link to="#" className="followerLink">
                //   Followed
                // </Link>
              ) : (
                  <></>
                // <Link
                //   to="#"
                //   className="followerLink"
                //   onClick={(e) => props.handleFollowClick(e, props.data)}
                // >
                //   Follow
                // </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </>

  );
}
